<template>
  <section id="about" class="section about">
    <div class="container">
      <div class="about__grid">
        <div class="about__head">
          <p v-reveal class="eyebrow"><span class="eyebrow__index">01</span>About us</p>
          <h2 v-reveal="80" class="section-title">
            Blockchain, DeFi and&nbsp;crypto — engineered with mathematical precision
          </h2>
        </div>
        <div v-reveal="160" class="about__text">
          <p class="about__lead">
            Formal Crypto specializes in&nbsp;digital projects development based on&nbsp;blockchain
            technology, DeFi and&nbsp;cryptocurrency.
          </p>
          <p>
            Great experience with a&nbsp;deep understanding of&nbsp;technology allows us
            to&nbsp;create customized products for&nbsp;our&nbsp;customers. We solve
            the&nbsp;problems of&nbsp;our business partners, regardless of&nbsp;their complexity.
          </p>
          <p>Our highly qualified developers can get involved with your team at&nbsp;any stage.</p>
        </div>
      </div>

      <ul class="stats">
        <li v-for="(item, i) in stats" :key="i" v-reveal="i * 80" class="stats__item">
          <span class="stats__index">/0{{ i + 1 }}</span>
          <span class="stats__num">
            <CountUp :to="item.num" /><span class="stats__plus">+</span>
          </span>
          <span class="stats__label">{{ item.label }}</span>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
import CountUp from '@/components/common/CountUp'

export default {
  name: 'Company',
  components: {
    CountUp
  },
  data() {
    return {
      stats: [
        { num: 15, label: 'Professional blockchain developers in our team' },
        { num: 20, label: 'Successfully implemented projects' },
        { num: 3, label: 'Years of blockchain development experience' },
        { num: 50, label: 'Deployed smart contracts' }
      ]
    }
  }
}
</script>
